// extracted by mini-css-extract-plugin
module.exports = {"vertical":"_3Ay0d","root":"u4Eip"};